import { CheckCircleIcon, XCircleIcon, PauseCircleIcon } from "@phosphor-icons/react";

export const DECISIONS = {
  approve: { label: "Approve", color: "#10b981", Icon: CheckCircleIcon },
  deny: { label: "Deny", color: "#e11d48", Icon: XCircleIcon },
  pend: { label: "Pend", color: "#f59e0b", Icon: PauseCircleIcon },
};

export const DecisionBadge = ({ decision, size = "sm" }) => {
  const d = DECISIONS[decision];
  if (!d) return null;
  const { Icon } = d;
  const px = size === "lg" ? "px-3 py-1.5 text-sm" : "px-2 py-1 text-xs";
  return (
    <span
      className={`inline-flex items-center gap-1.5 font-bold uppercase tracking-wide border ${px}`}
      style={{ color: d.color, borderColor: d.color, background: `${d.color}12` }}
      data-testid={`badge-${decision}`}
    >
      <Icon size={size === "lg" ? 16 : 13} weight="bold" />
      {d.label}
    </span>
  );
};
